<div class="modal-header pd-x2 justify-content-center">
  <div class="text-center">
    <h5 class="modal-title" *ngIf="activeTab === 'Active'">{{ "shipment.UpdateInformation" | cxTranslate }}</h5>
    <h5 class="modal-title" *ngIf="activeTab === 'Completed'">{{ "shipment.viewInformation" | cxTranslate }}</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="close('close')">
    <span aria-hidden="true">&times;</span>
  </button> -->
    <h6>{{ updateInspectionData?.formattedNominationNumber }}</h6>
  </div>
</div>
<div class="modal-body ">
  <div id="loader" *ngIf="enableLoader"></div>
  <div *ngIf="!enableLoader">
    <form [formGroup]="updateForm">
      <div class="mb-3 col-md-12 col-sm-12">
        <span class="semibold small">{{ "shipment.draftSurvey" | cxTranslate }}</span>
        <!-- Show info SVG if not validated, else show warning SVG if validation failed -->
        <!-- Info SVG before validation -->
        <img src="/images/info.svg" *ngIf="(azureStatus | lowercase)=='not_initiated'" [ngbTooltip]="'home.recordpickup.AzureNotValidated' | cxTranslate"
          alt="Not yet validated" width="20px" height="20px" />
        <!-- Warning SVG only after validation attempt and failure -->
        <img src="/images/warning.svg" *ngIf="(azureStatus | lowercase) === 'failure' "
          [ngbTooltip]="'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate" alt="Unsuccessful validation" width="20px" height="20px" />
        <!-- Success SVG only after validation attempt and success -->
        <img src="/images/check_circle.svg" *ngIf="(azureStatus | lowercase) === 'success' "
          [ngbTooltip]="'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate" alt="Validated successfully" width="20px" height="20px" />
        <img src="/images/pending.svg" *ngIf="(azureStatus | lowercase) === 'in_progress' " [ngbTooltip]="'home.recordpickup.AzureValidating' | cxTranslate"
          alt="In progress" width="20px" height="20px" />

        <input type="text" id="draftSurveyQty" name="draftSurveyQty" formControlName="draftSurveyQty"
          class="form-control" appAllowNegativeDecimalNumber [beforeDecimal]="6" [afterDecimal]="3"
          [ngClass]="{'disable-Click':activeTab === 'Completed'}" (input)="resetError()">
        <!-- <div class="text-danger" *ngIf="updateForm.controls.draftSurveyQty.touched &&  updateFormInValid ==true">{{'shipment.draftSurveyValidation'| cxTranslate}}</div>            -->
      </div>
      <div class="mb-3 col-md-12 col-sm-12">
        <span class="semibold small">{{ "shipment.startDate" | cxTranslate }}</span>
        <div class="input-group">
          <input class="form-control" placeholder="DD/MM/YYYY" name="surveyStartDate" ngbDatepicker #d="ngbDatepicker"
            formControlName="surveyStartDate" id="surveyStartDate" [readonly]="activeTab === 'Active'" required
            (click)="d.toggle()" (dateSelect)="onDateSelect($event);resetError()"
            [ngClass]="{'disable-Click':activeTab === 'Completed'}" [maxDate]="endDate" />
        </div>
        <!-- <div class="text-danger" *ngIf="updateForm.controls.surveyStartDate.touched && updateFormInValid ==true">{{'shipment.startdateValidation'| cxTranslate}}</div>            -->
      </div>
      <div class="mb-3 col-md-12 col-sm-12">
        <span class="semibold small">{{ "shipment.endDate" | cxTranslate }}</span>
        <div class="input-group">
          <input class="form-control" placeholder="DD/MM/YYYY" name="surveyEndDate" ngbDatepicker #e="ngbDatepicker"
            formControlName="surveyEndDate" id="surveyEndDate" [readonly]="activeTab === 'Active'" required
            [ngClass]="{'disable-Click':activeTab === 'Completed'}" (click)="e.toggle()"
            (dateSelect)="onEndDateSelect($event);resetError()" [minDate]="startDate" />
        </div>
        <!-- <div class="text-danger" *ngIf="updateForm.controls.surveyEndDate.touched && updateFormInValid ==true">{{'shipment.endDateValidation'| cxTranslate}}</div>            -->
      </div>
      <div class="mb-3 col-md-12 col-sm-12">
        <!-- file upload -->
        <div>
          <div class="dropdiv" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">

            <div class="">
              <div>
                <div class="d-flex justify-content-between pt-4 pl-2 pr-2 align-items-center">
                  <div class="d-flex justify-content-between">
                    <img src=".././images/upload-img.svg" class="p-2">
                    <div class="m-2">
                      <p class="mb-1">{{'shipment.selectFileLongText' | cxTranslate}}</p>
                      <p class="mb-1 text-secondary font-change">{{'shipment.fileSizeText'| cxTranslate}}</p>
                    </div>
                  </div>
                </div>
                <div class="mobile-view-button">
                  <label class="custom-file-upload btn btn-secondary btn-lg"
                     [ngClass]="{'disable-Click':activeTab === 'Completed' || (azureStatus | lowercase) === 'success'}">
                    <input accept="application/pdf, image/jpg, image/jpeg, image/png"
                      (onFileSelected)="onChange($event)" type="file" ng2FileSelect [uploader]="uploader"  [disabled]="activeTab === 'Completed' || (azureStatus | lowercase) === 'success'"/>
                    {{'shipment.selectFile'| cxTranslate}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div id="loader" *ngIf="startLoader"></div>
          <div *ngIf="filesLength || updateInspectionData.attachments">


            <div class="" *ngIf="!startLoader">
              <div class="filesection-mobile-check mt-2" *ngFor="let file of fileArray;let i=index;">
                <div class="d-flex file-block-height">
                  <div class="d-flex w-100 m-2">
                    <div class="d-flex align-items-center"><img src=".././images/file-alt.svg" class="p-2"></div>
                    <div class="p-2 w-100 text-break">
                      <p class="file_name file-name-height-1">{{file.name || file.documentName}}<a
                          *ngIf="file.downloadURL!=undefined" class="pt-2 btn btn-sm text-primary shadow-none small"
                          href="{{file.downloadURL}}">{{'shipment.preview' | cxTranslate}}</a></p>
                      <p class="file_size text-secondary">{{file.size / 1024 / 1024 | number: '.3'}}MB / {{file.size
                        /
                        1024 / 1024 | number: '.3'}}MB</p>
                    </div>
                    <div><i class="fa fa-times close-icon-file p-2" aria-hidden="true"
                        [ngClass]="{'disable-Click':activeTab === 'Completed' || (azureStatus | lowercase) === 'success'}" (click)="removeFile(i)"></i></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- attchment validation -->
        <div *ngIf="uploadErr == true">
          <div class="">
            <div class="filesection_warning mt-2 mb-2">
              <div class="d-flex">
                <div class="d-flex align-items-center w-100 m-2">
                  <img src="/icons/Vector.svg" class="p-2">
                  <div class="p-2 w-100">
                    <p class="upload_file_name">{{'shipment.uploadFileText'| cxTranslate}}</p>
                    <p class="upload_file_secondary_text">{{'shipment.uploadFileBelowText'| cxTranslate}}</p>
                  </div>
                </div>
                <div>
                  <i class="fa fa-times close-icon p-2" aria-hidden="true" (click)="removeWarning()"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12">
        <div *ngIf="(azureStatus | lowercase)=='not_initiated' && updateForm.get('inspectionCompleted')?.value === 'no'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/info.svg" ngbTooltip="{{'home.recordpickup.AzureNotValidated' | cxTranslate}}" alt="Not yet validated" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.saveChanges' | cxTranslate}}</span>

        </div>
        <div
          *ngIf="(azureStatus | lowercase)=='not_initiated' && updateForm.get('inspectionCompleted')?.value === 'yes'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/info.svg" ngbTooltip="{{'home.recordpickup.AzureNotValidated' | cxTranslate}}" alt="Not yet validated" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.validationResults' | cxTranslate}}</span>

        </div>
        <div *ngIf="(azureStatus | lowercase)=='in_progress' && updateForm.get('inspectionCompleted')?.value === 'yes'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/pending.svg" ngbTooltip="{{'home.recordpickup.AzureValidating' | cxTranslate}}" alt="In progress" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.dataSubmitted' | cxTranslate}}</span>

        </div>
        <!-- Validation error message -->
        <div *ngIf="(azureStatus | lowercase) === 'failure' && updateForm.get('inspectionCompleted')?.value === 'yes'"
          class="text-danger mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F; border-radius: 4px; display: flex;color: #5C1715">
          <img src="/images/warning.svg" ngbTooltip="{{'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate}}" alt="Unsuccessful validation" width="20px"
            height="20px">
          <span class="ml-2">{{azureValidationRemark}}</span>
        </div>
        <!-- Validation success message -->
        <div *ngIf="(azureStatus | lowercase) === 'success' && updateForm.get('inspectionCompleted')?.value === 'yes'"
          class="text-success mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F; border-radius: 4px; display: flex;color: #28A745">
          <img src="/images/check_circle.svg" ngbTooltip="{{'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate}}" alt="Validated successfully"
            width="20px" height="20px">
          <span class="ml-2">{{azureValidationRemark}}</span>
        </div>

      </div>
      <div class="mb-3 col-md-12 col-sm-12">
        <div class="d-flex justify-content-between">
          <div class="width-70">
            <label for="inspectionCompleted" class="form-label fw-bold">{{'shipment.inspectionCompleted'|
              cxTranslate}}</label>
          </div>

          <div class="col-md-2 col-sm-2 p-0 w-50">
            <div class="btn-group btn-group-toggle float-right p-0" data-toggle="buttons">
              <label id="yes" class="btn m-0 border b-dvl b-height" [ngClass]="uploaddoc==true? 'active_yes':''"
                (click)="selectInspection('yes');resetError()">
                <input type="radio" formControlName="inspectionCompleted" name="options" id="{{'optionyes'}}"
                  class="h6 btn btn-block btn-light m-0 border1" [disabled]="uploaddoc==true">{{'shipment.YES'|
                cxTranslate}}</label>
              <label id="no" class="btn m-0 border b-dvl b-height"
                [ngClass]="{'active_no': uploaddoc==false, 'disabled unabletoclick': updateInspectionData.shipmentInspectionStatusCode == 'COMPLETED'}"
                (click)="selectInspection('no')">
                <input type="radio" [disabled]="uploaddoc==true" formControlName="inspectionCompleted" name="options"
                  id="{{'optionno'}}" (click)="resetError()"
                  class="h6 btn btn-block btn-light m-0 border1">{{'shipment.NO'| cxTranslate}}</label>
            </div>
          </div>

        </div>
      </div>

      <div class="text-danger col-md-12 strong" *ngIf="invalidAnyone ==true">{{'shipment.anyoneRequired'| cxTranslate}}
      </div><!--{{'shipment.endDateValidation'| cxTranslate}}</div>  -->
      <div class="text-danger col-md-12 string" *ngIf="invalidAll ==true">{{'shipment.allRequired'| cxTranslate}}</div>

    </form>
  </div>

</div>
<div class="modal-footer" *ngIf="!enableLoader">
  <div class="col-md-12 col-sm-12">
    <div class="mb-2">
      <button
        *ngIf="((azureStatus | lowercase)=='not_initiated' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark=='') && updateForm.get('inspectionCompleted')?.value === 'yes' && updateInspectionData?.isStockAdjustmentSuccess !== true "
        type="button"
        class="btn btn-block btn-primary-record bg-transparent mr-2 justify-content-center align-items-center btn-lg"
        [disabled]="(azureStatus | lowercase)=='in_progress'" (click)="onValidateClick()">
        <span *ngIf="(azureStatus | lowercase)=='in_progress'" class="spinner-border spinner-border-sm mr-2"
          role="status" aria-hidden="true"></span>
        <img *ngIf="(azureStatus | lowercase)=='not_initiated'" src="/images/validate.svg" alt="Validate" width="20px"
          height="20px"> {{'home.recordpickup.validate' | cxTranslate }}
      </button>
      <button
        *ngIf="((azureStatus | lowercase)=='failure' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark!='') && updateForm.get('inspectionCompleted')?.value === 'yes' && updateInspectionData?.isStockAdjustmentSuccess !== true"
        type="button" [ngClass]="{'disable-Click':(azureStatus | lowercase)=='in_progress' && !showReValidate}" class="btn btn-block btn-primary-record bg-transparent justify-content-center align-items-center btn-lg"
        (click)="onRevalidateClick()" [disabled]="(azureStatus | lowercase)=='in_progress' && !showReValidate"
        style="display: flex; align-items: center; gap: 10px">
        <span *ngIf="(azureStatus | lowercase)=='in_progress' && !showReValidate" class="spinner-border spinner-border-sm mr-2"
          role="status" aria-hidden="true"></span>
        <img *ngIf="(azureStatus | lowercase)=='failure' || showReValidate " src="/images/restart_alt.svg" alt="Re-validate" width="20px"
          height="20px"> {{'home.recordpickup.reValidate' | cxTranslate }}</button>
        <button *ngIf="showReload && inspectionCompleted === 'yes' && !showReValidate" type="button" class="btn btn-block btn-lg btn-primary-record bg-transparent " (click)="getShipmentDetails()"> {{'home.recordpickup.Reload' | cxTranslate }} </button>
    </div>
    <button class="btn btn-block btn-lg  btn-primary" type="submit" (click)="submitUpdate(updateForm)"
      *ngIf="updateForm.get('inspectionCompleted')?.value === 'no' && !showNextButton"
      [disabled]="(activeTab === 'Completed')"> {{"shipment.save" | cxTranslate }}</button>
    <button class="btn btn-block btn-lg  btn-primary" type="submit" (click)="onNextClick(updateForm)"
      *ngIf="((updateForm.get('inspectionCompleted')?.value === 'yes' && (azureStatus | lowercase) !== 'not_initiated') || showNextButton) && !((azureStatus | lowercase) === 'success' && updateInspectionData?.inspectionCompleted)"
      [disabled]="(activeTab === 'Completed')">{{
      "shipment.next" | cxTranslate }}</button>
       
    <button class="btn btn-block btn-light btn-lg" type="submit" (click)="close('close')" data-dismiss="modal">{{
      "shipment.closetext" | cxTranslate }}</button>
  </div>
</div>